<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${pack.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="pack" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "package-view-logs",

  components: { LogListTable },

  props: ["pack"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    pack(pack) {},
  },
};
</script>
